import { ConfluenceWorkspaceAri, IdentityUserAri } from '@atlassian/ari';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useNetworkStorageParams = (): {
	activationId: string;
	entityId: string;
	ownerAri: string;
	firstPartyApp: string;
	siteId: string;
} => {
	const { cloudId, activationId, userId } = useSessionData();

	const ownerAri = (userId && IdentityUserAri.create({ userId }).toString()) || '';
	const entityId = ConfluenceWorkspaceAri.create({
		siteId: cloudId,
		activationId,
	}).toString();

	return {
		activationId,
		entityId,
		ownerAri,
		firstPartyApp: 'confluence',
		siteId: cloudId,
	};
};
